<template>
  <div class="iosbuy">
    <p class="title">小睡眠自动续费协议</p>
    <p style="text-align: left">发布时间：2021年12月01日<br/>
      生效时间：2021年12月01日<br/>
      更新时间：2023年08月24日</p>
    <p class="common-p">欢迎您使用会员/声音卡/宝宝卡自动续费服务！</p>
    <p class="common-p">《小睡眠自动续费协议》（简称“本协议”）是您与使用广州心与潮信息科技有限公司（简称：心潮科技）之间关于小睡眠产品提供“会员自动续费服务”和“声音卡自动续费服务”以及“宝宝卡订阅服务”的法律协议。您应当在充分阅读并明确理解的前提下，遵守本协议。</p>
    <p class="common-p">如果您未满18周岁，请在法定监护人陪同下或经过法定监护人同意后再使用本服务；未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可，本协议对您及您的法定监护人产生法律约束力。</p>

    <p class="common-p">本条款为《服务协议》和《隐私政策》的特别服务条款。请在接受使用会员与声音卡订阅服务前务必审慎阅读、充分理解《服务协议》和《隐私政策》及本条款的相应内容，并选择接受或不接受。本条款未予以约定的，适用《服务协议》和《隐私政策》的约定；本条款与《服务协议》和《隐私政策》有冲突的，以本条款为准。</p>
    <p class="two-title">一、服务说明</p>
    <p class="common-p">1.1本服务是在您开通会员、声音卡、宝宝卡服务等现有及未来新增/调整付费服务前提下，基于您对自动续费的需求，避免您因疏忽或其他原因导致未及时续费而中断服务所推出的服务。自动续费分为连续包月、连续包季、连续包半年、连续包年等多种订阅服务期类型，对应计费周期分为包月费用、包季费用、包半年费用、包年费用。</p>

    <p class="common-p">1.2如您通过苹果公司Apple ID开通本服务，且在下一个订阅服务到期前24小时前未主动取消本自动续费服务，则苹果公司将在每个订阅期即将到期前24小时，从您开通本自动续费服务时绑定的AppleID账户 (以下统称“账户”)余额中自动代扣下一个订阅期服务费，从而延长该订阅期对应的服务有效期。</p>

    <p class="common-p">1.3如您通过安卓(Android) 产品开通本服务，且在订阅服务期内未主动取消本自动续费服务，则相关主体将在会员/声音卡/宝宝卡即将到期前一天开始，从您开通本自动续费服务时绑定的自有充值账户、绑定的第三方支付账户(包括但不限于微信钱包账户、支付宝账户) 、银行卡、通讯账号等账户 (以下统称“账户”) 余额中自动代扣下一个会员期服务费，从而延长该订阅期对应的会员有效期。</p>

    <p class="common-p">1.4您理解并同意，因部分渠道由支付渠道根据实际情况自行决定扣费周期，前述自动续费服务的扣款时间以各渠道实际扣款时间为准。</p>

    <p class="common-p">1.5请您关注上述各类账户及可扣款余额状况，如因账户问题或余额不足导致续费失败而引发的风险或导致的损失将由您自行承担 （如相应权益终止、无法参与活动、会员身份等）。如您未主动明确选择取消本服务，将视为您同意小睡眠在订阅服务期满后的一定期限内进行不时的扣款尝试（具体以各支付渠道的扣款规则为准）。小睡眠将在您账户余额恢复充足时/后，继续为您提供自动续费服务，一旦扣款成功，小睡眠将继续为您提供付费权益。</p>

    <p class="common-p">1.6根据相关法律规定，为便于您知悉自动续费情况，小睡眠会在下一个订阅期扣款前5日以APP消息推送等方式通知您，第三方支付渠道也可能向您发出扣款前的提醒通知，请您注意接收。</p>

    <p class="common-p">1.7请您特别注意，基于自动续费服务的特点，自动代扣将按照本协议1.1、1.2、1.3、1.4、1.5、1.6条的约定方式和时间完成，如果您未在代扣之前明确取消自动续费服务，小睡眠将根据您的委托发出下一个订阅期的代扣指令，原则上对基于该指令扣除的费用将不予退还。</p>
    <p class="two-title">二、会员自动续费服务</p>
    <p class="common-p">1. 连续包月（包季、包半年、包年）是在您同意且开启会员订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的会员订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、半年卡、年卡）服务费用。</p>
    <p class="common-p">2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。</p>
    <p class="common-p">3. 您可通过下述途径取消已开通的连续包月（包季、包半年、包年）服务：</p>

    <p class="common-p">（1）苹果设备</p>
    <p class="common-p">在苹果手机或 iPad 的 “设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

    <p class="common-p">（2）华为&荣耀系列手机5.7.0 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <p class="common-p">5.7.0 以下的小睡眠App版本在“我的” → 选择“会员中心” → 选择“···” → 选择“管理续费” → 关闭“小睡眠会员包月自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

    <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
    <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

    <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
    <p class="common-p">5.7.0 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <p class="common-p">5.7.0 以下的小睡眠App版本在“我的” → 选择“会员中心” → 选择“···” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <!-- <p class="common-p">（5）vivo&其他Android系列手机</p>
    <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p> -->
    <p class="two-title">三、声音卡自动续费服务</p>
    <p class="common-p">1. 连续包月（包季、包年）是在您同意且开启声音卡订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的声音卡订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、年卡）服务费用。</p>

    <p class="common-p">2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。</p>

    <p class="common-p">3. 您可通过下述途径取消已开通的连续包月（包季、包年）服务：</p>

    <p class="common-p">（1）苹果手机</p>
    <p class="common-p">在苹果手机或 iPad 的“设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

    <p class="common-p">（2）华为&荣耀系列手机</p>
    <p class="common-p">在小睡眠App“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

    <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
    <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

    <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
    <p class="common-p">在小睡眠App“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
    <p class="two-title">四、宝宝卡自动续费服务</p>
    <!-- <p class="common-p" style="font-weight: bold">1. 自动续费会员服务与常规会员服务并存</p> -->
    <p class="common-p">1. 连续包月（包季、包半年、包年）是在您同意且开启宝宝卡订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的宝宝卡订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、半年卡、年卡）服务费用。</p>
    <p class="common-p">2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。</p>
    <p class="common-p">3. 您可通过下述途径取消已开通的连续包月（包季、包半年、包年）服务：</p>
    <p class="common-p">（1）苹果手机</p>
    <p class="common-p">在苹果手机或 iPad 的“设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

    <p class="common-p">（2）华为&荣耀系列手机</p>
    <p class="common-p">在小睡眠App“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

    <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
    <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
    <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

    <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
    <p class="common-p">在小睡眠App“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
    <p class="two-title">五、付费服务并存说明</p>
    <p class="common-p" style="font-weight: bold">1. 自动续费会员服务与常规会员服务并存</p>
    <p class="common-p">自动续费会员与常规会员服务出现并存的情况，将遵循自动续费的会员周期，优先使用连续包月（包季、包半年、包年）会员时长，常规会员服务时长则在原服务有效期的基础上延长。</p>
    <p class="common-p" style="font-weight: bold">2. 自动续费声音卡服务与常规声音卡服务并存</p>
    <p class="common-p">自动续费声音卡服务与常规声音卡服务出现并存的情况，将遵循自动续费的声音卡周期，优先使用连续包月（包季、包半年、包年）声音卡时长，常规声音卡服务时长则在原服务有效期的基础上延长。</p>
    <p class="common-p" style="font-weight: bold">3. 自动续费宝宝卡服务与常规宝宝卡服务并存</p>
    <p class="common-p">自动续费宝宝卡服务与常规宝宝卡服务出现并存的情况，将遵循自动续费的宝宝卡周期，优先使用连续包月（包季、包半年、包年）宝宝卡时长，常规宝宝卡服务时长则在原服务有效期的基础上延长。</p>
    <p class="common-p" style="font-weight: bold">4. 宝宝卡服务、声音卡服务与会员服务并存</p>
    <p class="common-p">宝宝卡服务、声音卡服务与会员服务并存的情况，将遵循两种服务时长并行存在的规则，即分别使用宝宝卡服务、声音卡服务与会员服务各自的有效时长，并享有对应的权益。</p>
    <p class="two-title">六、付费服务说明</p>
    <p class="common-p">（一）您理解并同意，会员/声音卡/宝宝卡订阅服务为付费服务，小睡眠将收取互联网增值服务使用费；您可以在相关服务页面查阅会员/声音卡/宝宝卡订阅服务具体期限及对应费用并自行选择服务的种类。开启会员/声音卡/宝宝卡订阅功能后，无论您是否在相应服务期限内实际使用该服务，已生效的服务费用不支持转让与退款。</p>
    <p class="common-p">（二）您理解并同意，心潮科技有权自行决定并不时修订会员/声音卡/宝宝卡订阅服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本条款的有效组成部分。如您不同意前述标准、规则及其修订，您有权停止使用会员/声音卡/宝宝卡订阅服务。您继续使用会员/声音卡/宝宝卡订阅服务即视为您同意相关内容。</p>
    <p class="two-title">七、未成年人使用条款</p>
    <p class="common-p">（一）若您未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用付费会员服务，并且已经获得监护人之同意。</p>
    <p class="common-p">（二）若监护人同意未成年人使用会员/声音卡/宝宝卡服务，必须以监护人名义申请消费，未成年人使用付费会员/声音卡/宝宝卡服务，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。</p>
    <p class="common-p">（三）请未成年人用户注意保护个人信息，合理安排使用网络的时间，避免沉迷于网络，影响日常的学习生活。</p>
    <p class="two-title">八、免责声明</p>
    <p class="common-p">心潮科技有权根据产品计划和运营情况独立决定会员/声音卡/宝宝卡订阅服务的具体内容，并有权根据内容的版权情况新增或移除内容或暂停、终止提供会员/声音卡/宝宝卡订阅服务的部分功能服务。前述决定不经通知即生效，您同意心潮科技对此免责。如您对上述条款有任何疑问请发送电子邮件到office@heartide.com。</p>
    <div class="block" style="text-align: right">
      <p>广州心与潮信息科技有限公司</p>
      <p>更新时间 2023年08月24日</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'android-buy',
  mounted () {
    document.getElementsByTagName("title")[0].innerHTML="&#65279;"
  }
}
</script>


<style lang="scss" scoped>
.iosbuy {
  p {
    color: initial;

    font-size: 16px;
  }
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: justify;
    margin: 20px 0;
  }
}
</style>
